// extracted by mini-css-extract-plugin
export default {"list":"DomainList_list__oQZsK"};